/** Public compile-time contract. This application never receives peer secrets. */
export const productionSupportAPIBase = "/api/v2/support";
export const nativeSupportStudioURL = "wenlix-support-review://studio";

export function parseSupportConfig(env: Record<string, unknown> = {}) {
  const base = env.VITE_SUPPORT_API_BASE ?? productionSupportAPIBase;
  if (base !== productionSupportAPIBase ||
      (env.VITE_SUPPORT_API_URL !== undefined && env.VITE_SUPPORT_API_URL !== "")) {
    throw new Error("Настройки поддержки недоступны.");
  }
  const mode = env.VITE_SUPPORT_STUDIO_MODE ?? "disabled";
  const url = env.VITE_SUPPORT_STUDIO_URL ?? "";
  if ((env.VITE_SUPPORT_STUDIO_NATIVE_REVIEW_URL ?? "") !== "" ||
      !((mode === "disabled" && url === "") ||
        (mode === "native" && url === nativeSupportStudioURL))) {
    throw new Error("Настройки открытия Studio недоступны.");
  }
  // Only navigation selectors cross this boundary. The installed native app
  // independently authenticates the employee and proves the live named grant.
  return { apiBase: productionSupportAPIBase,
    studioMode: mode as "disabled" | "native", studioUrl: url as string };
}

export const supportConfig = parseSupportConfig(import.meta.env ?? {});
